import WebFontLoader from 'phaser3-rex-plugins/plugins/webfontloader.js'

export enum MULTIPLIER_CYBER_SNAKES_TEXTURE_KEYS {
  ATLAS_NAME = 'MULTIPLIER_CYBER_SNAKES_ATLAS',
  CIRCLE_PURPLE_LARGE = 'MULTIPLIER_CYBER_SNAKES_CIRCLE_PURPLE_LARGE',
  CIRCLE_PURPLE_SMALL = 'MULTIPLIER_CYBER_SNAKES_CIRCLE_PURPLE_SMALL',
}

export enum MULTIPLIER_CYBER_SNAKES_ATLAS_KEYS {
  BACKGROUND = 'background.png',
  CIRCLE_BLUE_LARGE = 'circle-blue-large.png',
  CIRCLE_BLUE_OUTLINE_LARGE = 'circle-blue-outline-large.png',
  CIRCLE_PURPLE_LARGE = 'circle-purple-large.png',
  CIRCLE_PURPLE_OUTLINE_SMALL = 'circle-purple-outline-small.png',
  CIRCLE_PURPLE_SMALL = 'circle-purple-small.png',
  FONT = 'MULTIPLIER_CYBER_SNAKES_FONT',
  FOREGROUND = 'foreground.png',
  PULSE_SMALL_0 = 'pulse-small-0.png',
  PULSE_SMALL_1 = 'pulse-small-1.png',
  PULSE_LARGE_0 = 'pulse-large-0.png',
  PULSE_LARGE_1 = 'pulse-large-1.png',
  SNAKE_TRAIL_PARTICLE = 'particle-trail-circle.png',
}

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/cyber-snakes/`

  WebFontLoader.call(scene.load, {
    custom: {
      families: ['Jost'],
      urls: [`${prefix}fonts.css`],
    },
  })

  if (!scene.textures.getTextureKeys().includes(MULTIPLIER_CYBER_SNAKES_TEXTURE_KEYS.ATLAS_NAME)) {
    scene.load.atlas(
      MULTIPLIER_CYBER_SNAKES_TEXTURE_KEYS.ATLAS_NAME,
      `${prefix}multiplier-cyber-snakes-images.png`,
      `${prefix}multiplier-cyber-snakes-images.json`,
    )
  }
}
